import React, { useState, useImperativeHandle } from 'react';
import { Form, Input, Row, Col, Select, Button, Space, Divider } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import { PARAGRAPH, MULTIPLE } from '../../../../shared/types/fieldType';

const { Option } = Select;

function FormAdditionalInfo(props, ref) {
    const [properties, setProperties] = useState([]);

    useImperativeHandle(ref, () => ({
        onFetchFields: () => {
            var featureList = [];
            var formValues = props.form.getFieldsValue();

            properties.forEach(item => {
                featureList.push(formValues["property" + item.id]);
            });

            return featureList;
        },
        onLoad: (features) => {
            var data = features?.properties === undefined ? [] : features?.properties.map(m => ({ ...m, id: uuidv4() }));
            setProperties(data);
        }
    }));

    const onAddParagraph = () => {
        var propertiesTemp = properties.map(m => ({ ...m }));
        propertiesTemp.push({
            id: uuidv4(),
            type: PARAGRAPH,
            label: '',
            value: ''
        });

        setProperties(propertiesTemp);
    };

    const onAddMultiple = () => {
        var propertiesTemp = properties.map(m => ({ ...m }));
        propertiesTemp.push({
            id: uuidv4(),
            type: MULTIPLE,
            label: '',
            value: []
        });

        setProperties(propertiesTemp);
    };

    const onRemove = (row) => {
        var propertiesTemp = [];
        properties.forEach(item => {
            if (item.id !== row.id)
                propertiesTemp.push(item);
        });
        setProperties(propertiesTemp);
    };

    const inputType = (item) => {
        if (item.type === PARAGRAPH)
            return (
                <Input
                    size='large'
                    placeholder="Valor . . ."
                    autoComplete="off"
                />
            );

        if (item.type === MULTIPLE)
            return (
                <Select
                    size='large'
                    mode="tags"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    placeholder="Valores . . ."
                >
                    {item.value.map(_item => (
                        <Option
                            key={_item}
                            value={_item}
                            label={_item}
                        >
                            {_item}
                        </Option>
                    ))}
                </Select>
            );
    };

    return (
        <>
            <Space wrap className='mb-20 mt-10'>
                <Button
                    type='text'
                    icon={<PlusOutlined />}
                    onClick={onAddParagraph}
                    className='pl-5 pr-5'
                >
                    Parrafo
                </Button>
                <Divider type='vertical' className='fs-20 mr-0 ml-0' />
                <Button
                    type='text'
                    icon={<PlusOutlined />}
                    onClick={onAddMultiple}
                    className='pl-5 pr-5'
                >
                    Múltiple
                </Button>
            </Space>

            <Form.Item>
                <Col span={24} className='mt-10'>
                    {
                        properties.map(item => {
                            return (
                                <div className='inline-flex w-100'>
                                    <div className='w-100' >
                                        <Form.Item
                                            name={[`property${item.id}`, 'id']}
                                            fieldKey={[item.id, 'key']}
                                            style={{ display: 'none' }}
                                            initialValue={item.id}
                                        >
                                            <Input type="text" />
                                        </Form.Item>
                                        <Form.Item
                                            name={[`property${item.id}`, 'type']}
                                            fieldKey={[item.id, 'key']}
                                            style={{ display: 'none' }}
                                            initialValue={item.type}
                                        >
                                            <Input type="text" />
                                        </Form.Item>
                                        <Row gutter={20}>
                                            <Col xs={24} sm={9}>
                                                <Form.Item
                                                    label='Campo'
                                                    name={[`property${item.id}`, 'label']}
                                                    rules={[{ required: true, message: '' }]}
                                                    initialValue={item.label}
                                                    className='input-material'
                                                >
                                                    <Input
                                                        size='large'
                                                        placeholder="Campo"
                                                        autoComplete="off"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={15}>
                                                <Form.Item
                                                    label={item.type === PARAGRAPH ? 'Valor' : 'Valores'}
                                                    name={[`property${item.id}`, 'value']}
                                                    rules={[{ required: true, message: '' }]}
                                                    initialValue={item.value}
                                                    className='input-material'
                                                >
                                                    {
                                                        inputType(item)
                                                    }
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        <Button
                                            type='text'
                                            size='large'
                                            icon={<DeleteOutlined />}
                                            className="ml-5"
                                            onClick={() => onRemove(item)}
                                        />
                                    </div>
                                </div>
                            )
                        })
                    }
                </Col>
            </Form.Item>
        </>
    );
}
export default React.forwardRef(FormAdditionalInfo);